export var ANCHOR_ELEMENT_ROLE = {
    MOTIVATOR_COMPARISON_SCATTER_DOT: 'MOTIVATOR_COMPARISON_SCATTER_DOT',
    MOTIVATOR_COMPARISON_SCATTER_PERCENT_LABEL_NEUTRAL: 'MOTIVATOR_COMPARISON_SCATTER_PERCENT_LABEL_NEUTRAL',
    MOTIVATOR_COMPARISON_SCATTER_PERCENT_LABEL_NICE_TO_HAVE: 'MOTIVATOR_COMPARISON_SCATTER_PERCENT_LABEL_NICE_TO_HAVE',
    MOTIVATOR_COMPARISON_SCATTER_PERCENT_LABEL_NEED_TO_HAVE: 'MOTIVATOR_COMPARISON_SCATTER_PERCENT_LABEL_NEED_TO_HAVE'
};

//# sourceMappingURL=anchors.js.map